import { render, staticRenderFns } from "./UploadMenuItem.vue?vue&type=template&id=6b124404"
import script from "./UploadMenuItem.vue?vue&type=script&lang=ts"
export * from "./UploadMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports